import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueMoment from 'vue-moment';
import axios from 'axios';
import Vuetify from '@/plugins/vuetify/vuetify';
import 'vuetify/dist/vuetify.css';
import { languages, defaultLocale } from '@/plugins/i18n/languages';
import snackBar from '@/shared/snackbar/snackbar.service';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@/shared/filter/filter';
import router from './router';
import App from './App.vue';
import store from './store';
import httpRequester from './plugins/httpRequester';

Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VueMoment);
Vue.use(httpRequester);
Vue.prototype.$snackbar = snackBar;

const messages = Object.assign(languages);
const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'pt',
  messages,
});

axios.defaults.baseURL = process.env.VUE_APP_HOST_URL_BASE;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
